import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Col from 'reactstrap/lib/Col';
import { get, times } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { PhotoflipperModel, buildPhotosMediaPath } from 'client/data/models/photoflipper';
import { getPictureNumber } from 'client/site-modules/pictures/utils/gallery-utils';
import { BuildPriceAd } from 'site-modules/shared/components/native-ad/buildprice-ad/buildprice-ad';
import { SponsoredCars } from 'site-modules/shared/components/core-page/sponsored-cars/sponsored-cars';
import { MinHeightWrapper } from 'site-modules/shared/components/min-height-wrapper/min-height-wrapper';
import { GalleryPicturePlaceholder } from 'site-modules/pictures/components/gallery-picture-placeholder/gallery-picture-placeholder';
import { GalleryPicture } from 'site-modules/pictures/components/gallery-picture/gallery-picture';
import { Experiment, Recipe } from 'site-modules/shared/components/experiment';

// 12 is a common divider for 2, 3 and 4 (number of pictures in a row for every screen size)
const PLACEHOLDERS_COUNT = 12;

export function PlaceholderRow() {
  return times(PLACEHOLDERS_COUNT, ind => (
    <Col xs={6} md={4} lg={3} key={ind}>
      <GalleryPicturePlaceholder />
    </Col>
  ));
}

function GallerySectionUI({ pageContent = null, pageNum, params, isMobile = false }) {
  const photos = get(pageContent, 'data', []);

  if (!photos.length) {
    return <PlaceholderRow />;
  }

  const buildPriceAd = (
    <Col xs={12} className="mb-1 d-flex justify-content-center">
      <BuildPriceAd mobile={isMobile} wrapperClass="pictures-buildprice-ad col-md-12 d-flex justify-content-center" />
    </Col>
  );
  const sponsoredCarsAd = (
    <Col xs={12} className="mt-1_5 mb-2">
      <Experiment name="ads-12460_dfp" showDefault>
        <Recipe name="ctrl" isDefault>
          <MinHeightWrapper componentType="SPONSORED_CARS">
            <SponsoredCars wrapperClassName="pictures-sponsored-cars" />
          </MinHeightWrapper>
        </Recipe>
        <Recipe name="chal">
          <MinHeightWrapper componentType="SPONSORED_CARS_STACKED" style={isMobile ? null : { maxWidth: '744px' }}>
            <SponsoredCars wrapperClassName="pictures-sponsored-cars" showStackedAds />
          </MinHeightWrapper>
        </Recipe>
      </Experiment>
    </Col>
  );

  return (
    <Fragment>
      {photos.map((photo, ind) => {
        const pictureNumber = getPictureNumber({ pageNum, ind });
        return (
          <Fragment key={photo.src}>
            <Col xs={6} md={4} lg={3}>
              <GalleryPicture {...photo} params={{ ...params, pageNum }} num={pictureNumber} isMobile={isMobile} />
            </Col>
            {isMobile && pictureNumber === 10 && buildPriceAd}
            {!isMobile && pictureNumber === 24 && buildPriceAd}
            {isMobile && pictureNumber === 24 && sponsoredCarsAd}
            {!isMobile && pictureNumber === 60 && sponsoredCarsAd}
          </Fragment>
        );
      })}
    </Fragment>
  );
}

GallerySectionUI.propTypes = {
  pageContent: PropTypes.shape({}),
  params: PropTypes.shape({
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.string,
    submodel: PropTypes.string,
    category: PropTypes.string,
  }).isRequired,
  pageNum: PropTypes.number.isRequired,
  isMobile: PropTypes.bool,
};

export const mapStateToProps = ({ mobile }) => ({
  isMobile: mobile,
});

export const GallerySection = connect(mapStateToProps)(
  connectToModel(GallerySectionUI, {
    pageContent: bindToPath(
      ({ params, pageNum }) => pageNum && buildPhotosMediaPath({ ...params, pageNum }),
      PhotoflipperModel
    ),
  })
);
